import { render, staticRenderFns } from "./exbadgeList.vue?vue&type=template&id=120a5042&scoped=true"
import script from "./exbadgeList.vue?vue&type=script&lang=js"
export * from "./exbadgeList.vue?vue&type=script&lang=js"
import style0 from "./exbadgeList.vue?vue&type=style&index=0&id=120a5042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120a5042",
  null
  
)

export default component.exports